
export function scrollIntoViewWithOffset(elementId:string, offset:number) {

  const target = document.getElementById(elementId);

  if (target) {
    window.scrollTo({
      behavior: 'smooth',
      top: target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
    })
  }

}
